<template>
  <!--   Main Content Start Here   -->
  <main>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <section class="dashboard_wraper">
      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="statistics_holder">
              <div class="row">
                <div class="col-6 col-md-6 col-lg-3">
                  <div class="stat_col">
                    <div class="stat_col_top">
                      <div class="stat_col_icon">
                        <img src="/src/assets/images/pending-orders.svg" alt="" />
                      </div>
                      <h5>Pending Orders</h5>
                    </div>
                    <h2>{{order_count && order_count.waiting_pickup_count ? order_count.waiting_pickup_count : 0}}</h2>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-3">
                  <div class="stat_col">
                    <div class="stat_col_top">
                      <div class="stat_col_icon">
                        <img src="/src/assets/images/processed-order.svg" alt="" />
                      </div>
                      <h5>Processed Orders</h5>
                    </div>
                    <h2>{{order_count && order_count.ready_to_deliver_count ? order_count.ready_to_deliver_count : 0}}</h2>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-3">
                  <div class="stat_col">
                    <div class="stat_col_top">
                      <div class="stat_col_icon">
                        <img src="/src/assets/images/cancelled-order.svg" alt="" />
                      </div>
                      <h5>Cancelled Orders</h5>
                    </div>
                    <h2>0</h2>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-3">
                  <div class="stat_col">
                    <div class="stat_col_top">
                      <div class="stat_col_icon">
                        <img src="/src/assets/images/completed-orders.svg" alt="" />
                      </div>
                      <h5>Completed Orders</h5>
                    </div>
                    <h2>{{order_count && order_count.completed_count ? order_count.completed_count : 0}}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="dashboard_card">
              <h2>Latest Orders</h2>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">Date</th>
                      <th scope="col">Name</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="orders && orders.length">
                    <!-- Leave First Row Empty -->
                    <tr>
                      <td colspan="6"></td>
                    </tr>

                    <!-- Loop Start Here -->
                    <tr v-for="data in orders" :key="data.id">
                      <td>{{data.id}}</td>
                      <td>{{data.formated_created}}</td>
                      <td> {{
                            data.order_user && data.order_user.full_name
                              ? data.order_user.full_name
                              : ""
                          }}</td>
                      <td>${{data.total}}</td>
                      <td>
                       <span
                            class="requested_order"
                            v-if="data.status == '0'"
                            >Cleaning</span
                          >
                          <span
                            class="processed_order"
                            v-if="data.status == '1'"
                            >Cleaned and Ready to Deliver</span
                          >
                          <span
                            class="completed_order"
                            v-if="data.status == '2'"
                            >Completed</span
                          >
                          <span
                            class="processed_order"
                            v-if="data.status == '4'"
                            >Awaiting Pickup</span
                          >
                      </td>
                      <td>
                        <router-link
                            :to="{
                              name: 'admin-order-details',
                              params: { id: data.id, type:'view' },
                            }"
                            class="table_action"
                            ><img src="/src/assets/images/view-icon.svg" alt=""
                          /></router-link>
                         <router-link
                            :to="{
                              name: 'admin-order-details',
                              params: { id: data.id, type:'edit' },
                            }" class="table_action"
                          ><img src="/src/assets/images/edit-icon.svg" alt=""
                        /></router-link>
                        <a
                          href="#"
                          class="table_action"
                          @click="deleteModal(data.id)"
                          ><img src="/src/assets/images/del-icon.svg" alt=""
                        /></a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="!orders || !orders.length">
                    <!-- Leave First Row Empty -->
                    <tr>
                      <td colspan="6"></td>
                    </tr>
                    <tr>No order created yet</tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

       <!-- Delete Modal -->
    <div
      class="modal fade"
      id="delete_order"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="close_modal">
              <button type="button" data-bs-dismiss="modal" aria-label="Close">
                <i class="fi fi-rr-cross-small"></i>
              </button>
            </div>
            <div class="modal_content">
              <h2>Delete Order</h2>
              <p>Are you sure want to delete this Order?</p>
              <div class="modal_buttons">
                <button
                  type="button"
                  class="button secondary_button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <button
                  type="button"
                  class="button primary_button"
                  @click.prevent="deleteOrder()"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end delete modal -->
    </section>
  </main>
  <!--   Main Content End Here   -->
</template>

<script>
import usersApis from '../../Apis/users';
import { getCurrentUserId } from '../../utils/auth';
import sidebarComponent from "./sidebar";
import moment from 'moment';

export default {
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,

      errors: null,
      status: null,

       orders: null,
      deleted_id: null,

      order_count: null,
    };
  },
  methods: {
    deleteModal(id) {
      this.deleted_id = id;

      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.show();
    },
    async deleteOrder() {
      console.log("dddd");
      this.loader = true;

      await usersApis.deleteOrder(this.deleted_id);

      this.deleted_id = null;
      this.getOrders();
      var myModal = new bootstrap.Modal(
        document.getElementById("delete_order")
      );
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

       this.loader = false;
    },

    async getOrders() {
      let user_id = getCurrentUserId();
      const response = (await usersApis.getUserOrder(user_id)).data;
      if (response && response.Orders) {
        response['Orders'].forEach((element) => {
          element.formated_created = moment
            .unix(element.createdDate)
            .format("MM-DD-YYYY");
          return element;
        });
        this.orders = response['Orders'];
      }

      if(response && response.count){
        this.order_count = response.count;
      }
    },
    
  },
  created() {
 this.loader = false;
   
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/dashboard.vue